var _ellipse, _ellipse2, _ellipse3, _ellipse4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.2,
    cy: 8.4,
    rx: 2.1,
    ry: 2.7,
    transform: "rotate(-18 7.2 8.4)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8,
    cy: 8.4,
    rx: 2.1,
    ry: 2.7,
    transform: "rotate(18 16.8 8.4)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.6,
    cy: 13.2,
    rx: 1.8,
    ry: 2.3,
    transform: "rotate(-38 3.6 13.2)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.4,
    cy: 13.2,
    rx: 1.8,
    ry: 2.3,
    transform: "rotate(38 20.4 13.2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.2c2.9 0 5.6 2.4 5.6 5.1 0 1.9-1.4 3.2-3.2 3.2-.9 0-1.7-.3-2.4-.3s-1.5.3-2.4.3c-1.8 0-3.2-1.3-3.2-3.2 0-2.7 2.7-5.1 5.6-5.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.64fa80e96d68054c67dd7e69da09837c.svg";
export { ForwardRef as ReactComponent };